<ng-container *ngIf="!!legalBlockContent && legalBlockContent.length">
  <div class="bt b--medium-gray" *ngFor="let legalText of legalBlockContent" id="legal-block">
    <div class="page-margin jb-max-width center">
      <jb-inner-html
        jbSmartLink
        class="jb-grid gr-unset one-up grid-offset-l grid-offset-m mv5 mv7-ns mv8-l legal"
      >
        <div [innerHTML]="legalText.content"></div>
      </jb-inner-html>
    </div>
  </div>
</ng-container>
